import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./containers/Home";
import NotFound from "./components/NotFound";
import Layout from "./hocs/Layout";

const App = () => (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
);

export default App;
